<template>
  <div class="suggest">
    <h2 class="suggest__title">{{ $t('wei-wo-tui-jian') }}</h2>

    <div class="suggest__list">
      <CardItem
        v-for="item in similarData?.data.results.slice(0, 12)"
        :key="item.id"
        :data="item"
        :share="false"
        :collect="false"
        @cover-click="onHandleClick(item)"
        @preview-click="onHandlePreviewClick(item)"
      />
    </div>

    <BaseButton :variant="'border-white-middle'" class="suggest__button" @click="onHandleMoreClick">
      {{ $t('cha-kan-geng-duo-mo-ban') }}
      <template #icon>
        <IconMoreRight class="template-detail__button-icon" />
      </template>
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
import { useTemplateDetail } from '@/hooks/useModal/modals/template';
import { useRouter } from 'vue-router';
import { getSimilarList } from '~/api/';
import type { Template } from '~/api/interface';
import { PageKey } from '~/constants/page';
import BaseButton from '~/design/components/buttons/base.vue';
import IconMoreRight from '~/design/icons/more-right.svg?component';
import CardItem from '~/features/template/components/cardItem.vue';

const router = useRouter();

const props = defineProps<{
  templateId: number;
}>();

const { data: similarData } = useAsyncData(() => {
  return getSimilarList({
    template_id: props.templateId,
  });
});

const onHandleClick = (item: Template) => {
  router.push({
    name: PageKey.TEMPLATE_INFO,
    params: {
      id: item.id,
    },
  });
};

const onHandlePreviewClick = (item: Template) => {
  useTemplateDetail([item], item, {
    templateSource: TEMPLATE_SOURCE.SIMILAR_RECOM,
    source: SOURCE.TEMPLATE_CENTER,
  });
};

const onHandleMoreClick = () => {
  router.push({
    name: PageKey.TEMPLATE,
  });
};
</script>

<style lang="scss" scoped>
.suggest {
  margin-top: 24px;
  width: clamp(1200px, 1200px + (100vw - 1600px) * 0.75, 1440px);
  margin: 0 auto;

  .suggest__title {
    font-size: 48px;
    line-height: 67px;
    text-align: center;
    font-weight: var(--x-weight-regular);
    color: var(--x-text-1);
    margin-bottom: 80px;
  }

  .suggest__list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px 24px;
  }

  .suggest__button {
    display: flex !important;
    padding-inline: 32px;
    margin: 80px auto 160px;
  }

  .template-detail__button-icon {
    height: 22px;
    width: 22px;
  }
}
</style>
